const Stats = ({ items }) => {
  return (
    <div className="hunterbox__stats">
      {items.length >= 1 ? (
        items.map((item) => (
          <div key={item.displayName} className="hunterbox__stats__item-container">
            <div className="hunterbox__stats__numbers-container">
              <span className="hunterbox__stats__item-percent">%{item.percentage}</span>
              <span className="hunterbox__stats__item-count">{item.count}</span>
            </div>
            <span className="hunterbox__stats__item-name">{item.displayName}</span>
          </div>
        ))
      ) : (
        <div className="hunterbox__stats__item-container">
          <span className="hunterbox__stats__no-data">-</span>
        </div>
      )}
    </div>
  );
};

export default Stats;
